export function toLatinDigits(value: string): string {
  return value
    .replace(/[۰-۹]/g, (d) => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(d)))
    .replace(/[٠-٩]/g, (d) => String('٠١٢٣٤٥٦٧٨٩'.indexOf(d)));
}

export function isLatinName(value: string): boolean {
  return /^[A-Za-z][A-Za-z '-]*$/.test(value.trim());
}

export function isValidNationalCode(value: string): boolean {
  const code = toLatinDigits(value).trim();
  if (!/^\d{10}$/.test(code) || /^(\d)\1{9}$/.test(code)) return false;
  const digits = code.split('').map(Number);
  const sum = digits.slice(0, 9).reduce((acc, d, i) => acc + d * (10 - i), 0);
  const remainder = sum % 11;
  const check = digits[9];
  return remainder < 2 ? check === remainder : check === 11 - remainder;
}

export function normalizeMobile(value: string): string {
  return toLatinDigits(value).replace(/[\s-]/g, '');
}

export function isValidMobile(value: string): boolean {
  return /^(?:\+98|0098|0)?9\d{9}$/.test(normalizeMobile(value));
}

export function isIsoDate(value: string): boolean {
  return /^\d{4}-\d{2}-\d{2}$/.test(value);
}
